var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconDraw = function SvgS2IconDraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    "data-name": "strokes"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.53 1.999c-1.27-1.042-3.225-.9-4.449.324L3.105 12.3c-.319.317-.557.716-.689 1.15l-1.384 4.584a.75.75 0 0 0 .935.935l4.585-1.384c.433-.132.832-.37 1.148-.688L17.777 6.818A3.252 3.252 0 0 0 17.53 2ZM7.468 15.006l-2.48-2.47 6.858-6.857 2.475 2.475-6.853 6.852Zm-4.596 2.122.98-3.244c.026-.09.066-.173.11-.252l2.413 2.402a1.236 1.236 0 0 1-.258.114l-3.245.98Zm13.845-11.37L15.38 7.093 12.907 4.62l1.235-1.235a1.98 1.98 0 0 1 1.39-.586c.38 0 .751.118 1.049.361.392.321.621.774.647 1.274.024.493-.163.976-.511 1.325Z"
  })));
};
export default SvgS2IconDraw;